import { Pipe, PipeTransform } from '@angular/core';
import { Contract } from "../../classes/contract";

@Pipe({
  name: 'contractFilter',
  pure: false
})
export class ContractFilterPipe implements PipeTransform {

  transform(contractList: Array<Contract>, filterValue: string): any {
    if (!contractList || !filterValue) {
      return contractList;
    }
    return contractList.filter((contract: Contract) => {
      return contract.code.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 ||
          contract.name.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 ||
          contract.checklist.name.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;
    });
  }

}
